import "./ArrowDown.scss";

const ArrowDown = () => {
  return (
    <div className="circle-arrow-down">
      <div className="arrow-down"></div>
    </div>
  );
};

export default ArrowDown;
